export default "__VITE_ASSET__DjHYKWJ2__"